import { sendSegmentEvent, sendSegmentEventWithTimeout } from '@/lib/segment';

export const INVALID_EMPLOYER_ENTERED_EVENT = 'Invalid Employer Entered';

export const INVALID_EMPLOYER_SOURCES = {
  registrationAddEmployer: 'registration_add_employer',
  bhBenefitsCheckEligibility: 'bh_benefits_check_eligibility',
} as const;

export type InvalidEmployerFailureReason = 'not_in_list' | 'no_benefit_match';

export type InvalidEmployerTrackingPayload = {
  employerEntered: string;
  bhClientId?: string;
  failureReason: InvalidEmployerFailureReason;
  source: string;
};

export function invalidEmployerEnteredProperties(payload: InvalidEmployerTrackingPayload) {
  return {
    employerEntered: payload.employerEntered,
    bhClientId: payload.bhClientId || '',
    failureReason: payload.failureReason,
    source: payload.source,
  };
}

export function trackInvalidEmployerEntered(payload: InvalidEmployerTrackingPayload): Promise<void> {
  return sendSegmentEvent(INVALID_EMPLOYER_ENTERED_EVENT, invalidEmployerEnteredProperties(payload));
}

export function trackInvalidEmployerEnteredWithTimeout(
  payload: InvalidEmployerTrackingPayload,
  timeoutMs?: number
): Promise<void> {
  const properties = invalidEmployerEnteredProperties(payload);

  if (timeoutMs === undefined) {
    return sendSegmentEventWithTimeout(INVALID_EMPLOYER_ENTERED_EVENT, properties);
  }

  return sendSegmentEventWithTimeout(INVALID_EMPLOYER_ENTERED_EVENT, properties, timeoutMs);
}
